// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Filter$ReactHooksTemplate = require("../filters/filter.res.js");
var AxisData$ReactHooksTemplate = require("./axisData.res.js");
var DataWindowSettings$ReactHooksTemplate = require("./dataWindowSettings.res.js");
var ChartComponentColor$ReactHooksTemplate = require("./chartComponentColor.res.js");

function data(t) {
  return t.data;
}

function dataLength(t) {
  var data = t.data;
  if (data === undefined) {
    return 0;
  }
  var data$1 = Js_json.decodeArray(data);
  if (data$1 !== undefined) {
    return data$1.length;
  } else {
    return 0;
  }
}

function layout(t) {
  var match = t.layout;
  if (match === "vertical") {
    return "vertical";
  } else {
    return "horizontal";
  }
}

function xAxis(t) {
  return t.xAxis;
}

function yAxis(t) {
  return t.yAxis;
}

function yAxisList(t) {
  return t.yAxisList;
}

function colors(t) {
  return t.colors;
}

function onClick(t) {
  return t.onClick;
}

function width(t) {
  return t.width;
}

function height(t) {
  return t.height;
}

function enableLabel(t) {
  return t.enableLabel;
}

function enableCartesianGrid(t) {
  return t.enableCartesianGrid;
}

function showTick(t) {
  return t.showTick;
}

function valueSuffix(t) {
  return t.valueSuffix;
}

function showLabelsOnlyWhenEnlarged(t) {
  return t.showLabelsOnlyWhenEnlarged;
}

function dataWindowSettings(t) {
  return t.dataWindowSettings;
}

function innerRadius(t) {
  return t.innerRadius;
}

function outerRadius(t) {
  return t.outerRadius;
}

function enableDataWindow(t) {
  var match = DataWindowSettings$ReactHooksTemplate.enableCriteria(t.dataWindowSettings);
  if (match === "Always") {
    return true;
  } else {
    return dataLength(t) > DataWindowSettings$ReactHooksTemplate.limit(t.dataWindowSettings);
  }
}

var decodeFilter = Filter$ReactHooksTemplate.decodeFilterItem;

function decodeOnClick(json) {
  var onClick = Json_decode.field("action", Json_decode.string, json);
  if (onClick === "jump_to") {
    return {
            TAG: "GotoDashboard",
            _0: Json_decode.field("dashboard_name", Json_decode.string, json)
          };
  } else if (onClick === "filter") {
    return {
            TAG: "DrillDown",
            _0: Json_decode.field("filter", decodeFilter, json)
          };
  } else {
    return "NoAction";
  }
}

function fromJson(json) {
  var data = Belt_Option.getWithDefault(Js_json.decodeObject(json), {});
  return {
          data: Js_dict.get(data, "data"),
          layout: Json_decode.withDefault(undefined, (function (param) {
                  return Json_decode.field("layout", (function (param) {
                                return Json_decode.optional(Json_decode.string, param);
                              }), param);
                }), json),
          xAxis: Json_decode.field("x_axis", AxisData$ReactHooksTemplate.decode, json),
          yAxisList: Json_decode.withDefault(/* [] */0, (function (param) {
                  return Json_decode.field("y_axis_list", (function (param) {
                                return Json_decode.list(AxisData$ReactHooksTemplate.decode, param);
                              }), param);
                }), json),
          yAxis: Json_decode.field("y_axis", (function (param) {
                  return Json_decode.list(AxisData$ReactHooksTemplate.decode, param);
                }), json),
          onClick: Json_decode.withDefault("NoAction", (function (param) {
                  return Json_decode.field("on_click", decodeOnClick, param);
                }), json),
          colors: ChartComponentColor$ReactHooksTemplate.make(Json_decode.optional((function (param) {
                      return Json_decode.field("colors", (function (param) {
                                    return Json_decode.list(Json_decode.string, param);
                                  }), param);
                    }), json)),
          width: Json_decode.optional((function (param) {
                  return Json_decode.field("width", Json_decode.string, param);
                }), json),
          height: Json_decode.optional((function (param) {
                  return Json_decode.field("height", Json_decode.string, param);
                }), json),
          enableLabel: Json_decode.optional((function (param) {
                  return Json_decode.field("enable_label", Json_decode.bool, param);
                }), json),
          enableCartesianGrid: Json_decode.optional((function (param) {
                  return Json_decode.field("enable_cartesian_grid", Json_decode.bool, param);
                }), json),
          showTick: Json_decode.optional((function (param) {
                  return Json_decode.field("show_tick", Json_decode.bool, param);
                }), json),
          valueSuffix: Json_decode.optional((function (param) {
                  return Json_decode.field("value_suffix", Json_decode.string, param);
                }), json),
          showLabelsOnlyWhenEnlarged: Json_decode.withDefault(false, (function (param) {
                  return Json_decode.field("show_labels_only_when_enlarged", Json_decode.bool, param);
                }), json),
          dataWindowSettings: Json_decode.field("settings", (function (param) {
                  return Json_decode.field("data_window", DataWindowSettings$ReactHooksTemplate.decode, param);
                }), json),
          innerRadius: Json_decode.field("settings", (function (param) {
                  return Json_decode.optional((function (param) {
                                return Json_decode.field("inner_radius", Json_decode.string, param);
                              }), param);
                }), json),
          outerRadius: Json_decode.field("settings", (function (param) {
                  return Json_decode.optional((function (param) {
                                return Json_decode.field("outer_radius", Json_decode.string, param);
                              }), param);
                }), json)
        };
}

exports.data = data;
exports.dataLength = dataLength;
exports.layout = layout;
exports.xAxis = xAxis;
exports.yAxis = yAxis;
exports.yAxisList = yAxisList;
exports.colors = colors;
exports.width = width;
exports.height = height;
exports.enableLabel = enableLabel;
exports.enableCartesianGrid = enableCartesianGrid;
exports.fromJson = fromJson;
exports.onClick = onClick;
exports.showTick = showTick;
exports.valueSuffix = valueSuffix;
exports.showLabelsOnlyWhenEnlarged = showLabelsOnlyWhenEnlarged;
exports.dataWindowSettings = dataWindowSettings;
exports.enableDataWindow = enableDataWindow;
exports.innerRadius = innerRadius;
exports.outerRadius = outerRadius;
/* Filter-ReactHooksTemplate Not a pure module */
